import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/home.css";
import phone from "../assets/phone.png";

const Home = () => {
  const phoneRef = useRef(null);

  useEffect(() => {
    if (phoneRef.current) {
      //add the phone-search class to the phone image
      setTimeout(() => {
        phoneRef.current.classList.remove("phone-search");
      }, 1);
    }
  }, []);

  return (
    <div className="home">
      <Header />
      <div className="home-body">
        <div className="hero">
          <div className="hero-text">
            <h1>Stop Refreshing Hokie Spa</h1>
            <h2>
              Get a <span>text or email</span> anytime a spot opens up for{" "}
              <span>any course number</span>
            </h2>
          </div>
          <Link to="/search" className="primary-button">
            Search
          </Link>
          <div className="hero-assets">
            <img src={phone} alt="Phone" className="phone phone-search"  ref={phoneRef} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
